import { AvailabilityTimeModel, IdNameItemModel, SlotType } from "types/generated/models";

export enum BookingType {
    CLIENT = "Client",
    CLASS = "Class",
}

export interface IAvailabilityData {
    timeEntry: AvailabilityTimeModel;
    selectedProvider?: IdNameItemModel;
    date: string;
    displayText: string;
}

export interface IProviderData {
    providerId: number;
    providerName: string;
    providerStripeAccount?: string;
}

export interface IGroupData {
    groupId: string;
    groupName: string;
}

export interface ITimeEntry {
    dateTimeOffset: string;
    start: string;
    duration: number;
    name: string | null;
    description: string | null;
    appointmentId: number | null;
    providerId: number | null;
    providers: IdNameItemModel[] | null;
    locationId: number | null;
    type: SlotType;
    isBooked: boolean;
}
